import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatRippleModule} from '@angular/material/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatTabsModule} from '@angular/material/tabs';
import {MatTooltipModule} from '@angular/material/tooltip';

import {ChatStoreModule} from "../store/store.module";


import {MatToolbarModule} from "@angular/material/toolbar";
import {MatMenuModule} from "@angular/material/menu";
import {ChatGrupoFormComponent} from "./chat-grupo-form.component";
import {ImageCropperModule} from "ngx-image-cropper";
import {ChatMensagemHeaderModule} from "../chat-mensagem-header/chat-mensagem-header.module";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatAutocompleteModule} from "@angular/material/autocomplete";

@NgModule({
    imports: [MatButtonModule, MatFormFieldModule, MatIconModule, MatInputModule, MatTabsModule, MatToolbarModule, MatMenuModule, MatTooltipModule, MatRippleModule, ChatStoreModule, MatAutocompleteModule, ImageCropperModule, ChatMensagemHeaderModule, MatProgressSpinnerModule, ChatGrupoFormComponent],
    providers: [],
    exports: [
        ChatGrupoFormComponent
    ]
})
export class ChatGrupoFormModule
{
}
